// extracted by mini-css-extract-plugin
module.exports = {"popup":"MiniBots_popup__2Gg5p","btn":"MiniBots_btn__3TKc8","addBtn":"MiniBots_addBtn__UHSyd","linkBtn":"MiniBots_linkBtn__2y5jh"};